import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {DevicesService} from '../../../services/devices.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, concatMap, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { DeviceActions } from '../actions/device.actions';





@Injectable()
export class DeviceEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private deviceService = inject(DevicesService);

  constructor() {}

  ReadDeviceInfo$ = createEffect(() => this.actions$.pipe(
     ofType(featureActions.DeviceActionTypes.GetDevices),
     map((action: featureActions.GetDevices) => action.payload),
     withLatestFrom(this.store$.select(fromStore.getDeviceIds)),
     concatMap(([payload, deviceIds]) => {
       const source = Array.from(new Set(payload)),
           exist: any = deviceIds;
       const minus = source.filter(x => !exist.includes(x) && !!x);
       return of(minus);
     }),
     withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
     concatMap(([minus, user]) => {
       if (minus.length === 0) {
         return of(new featureActions.NoDevicesChanged());
       }
       return this.deviceService.ReadDeviceInfo(user.otp, minus,[],true).pipe(
         map((res: any) => {
           return new featureActions.UpsertDevices({devices: res});
         }),
         // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
         catchError(error => {
           return of(new featureActions.GetDevicesFail());
         })
       );
     })
   ));
  ReadDeviceInfoByAcodeList$ = createEffect(() => this.actions$.pipe(
     ofType(featureActions.DeviceActionTypes.GetDevicesByAcodeList),
     withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
     switchMap(([action, user]: [any, any]) => {
      const acodeList = action.payload;
       return this.deviceService.ReadDeviceInfo(user.otp, [],acodeList,false).pipe(
         map((res: any) => {
           return new featureActions.UpsertDevices({devices: res});
         }),
         // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
         catchError(error => {
           return of(new featureActions.GetDevicesFail());
         })
       );
     })
   ));
}
